export const FONT_LOAD_TIMEOUT_MS = 8000;

export const delay = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

export const withTimeout = <T>(task: Promise<T>, ms: number) =>
	new Promise<T>((resolve, reject) => {
		const timer = setTimeout(() => reject(new Error(`Font load timed out after ${ms} ms`)), ms);
		task.then(resolve, reject).finally(() => clearTimeout(timer));
	});
